var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-area-page" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [_c("Navigation", { attrs: { page: "billing" } })],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "9" } }, [
                _c("h1", [_vm._v("Verrechnung")]),
                _vm._v(" "),
                _c("div", { staticClass: "tag-sections" }, [
                  _c(
                    "section",
                    [
                      _vm.customer
                        ? [
                            _vm.customer.subscription
                              ? _c("div", [
                                  _c("h2", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\tAbonnement:\n\t\t\t\t\t\t\t\t\t"
                                    ),
                                    _c(
                                      "span",
                                      {
                                        class:
                                          "ml-1 color-" +
                                          _vm.getProductColor(
                                            _vm.customer.subscription.productId
                                          )
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.customer.subscription
                                                .productLabel
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("b", [_vm._v("End-Datum:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("date")(
                                            _vm.customer.subscription.endDate
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    ),
                                    _vm.followUpProductId
                                      ? _c("span", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t| Wechsel auf:\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c(
                                            "span",
                                            {
                                              class:
                                                "color-" +
                                                _vm.getProductColor(
                                                  _vm.followUpProductId
                                                )
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.followUpProductLabel
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("b", [_vm._v("Aktiv:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.customer.subscription.active
                                            ? "ja"
                                            : "nein"
                                        )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.customer.subscription.active
                                    ? _c("div", [
                                        _c("b", [
                                          _vm._v("Automatische Verlängerung:")
                                        ]),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.customer.subscription
                                                .autoRenew
                                                ? "ja"
                                                : "nein"
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.customer.subscription.active
                                    ? _c("div", [
                                        _c("b", [
                                          _vm._v(
                                            "Maximale Kontaktierungen im Vertragszeitraum:"
                                          )
                                        ]),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.customer.subscription
                                                .possibleContacts ||
                                                "unlimitiert"
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                        _vm.customer.subscription
                                          .possibleContacts &&
                                        _vm.customer.contactingInfo
                                          ? _c("span", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t(Bisherige Kontaktierungen: " +
                                                  _vm._s(
                                                    _vm.customer.contactingInfo
                                                      .consumedContacts
                                                  ) +
                                                  ")\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center mt-3"
                                    },
                                    [
                                      _vm.customer.subscription.active
                                        ? [
                                            _c("Button", {
                                              attrs: {
                                                text: "Abonnement bearbeiten",
                                                smaller: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.showEditPopUp = true
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.customer
                                              .subscriptionUpgradePossible
                                              ? _c("Button", {
                                                  staticClass: "ml-3",
                                                  attrs: {
                                                    text: "Abonnement upgraden",
                                                    smaller: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.showUpgradePopUp = true
                                                    }
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        : [
                                            _c("Button", {
                                              attrs: {
                                                text: "Abonnement verlängern",
                                                smaller: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.showPurchasePopUp = true
                                                }
                                              }
                                            })
                                          ]
                                    ],
                                    2
                                  )
                                ])
                              : _c("div", [
                                  _c("h2", [_vm._v("Abonnement")]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v("Kein aktives Abonnement vorhanden.")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mt-3" },
                                    [
                                      _c("Button", {
                                        attrs: {
                                          text: "Jetzt abonnieren",
                                          smaller: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.showPurchasePopUp = true
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    [
                      _c("h2", [_vm._v("Rechnungen")]),
                      _vm._v(" "),
                      _c("TransactionList", {
                        attrs: {
                          "none-text":
                            "Es sind noch keine Rechnungen vorhanden."
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPurchasePopUp || _vm.showUpgradePopUp
        ? _c("PurchaseSubscriptionPopUp", {
            attrs: { "is-upgrade": _vm.showUpgradePopUp },
            on: { hidden: _vm.onHidePurchasePopUp }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditPopUp
        ? _c("EditSubscriptionPopUp", {
            attrs: { subscription: _vm.customer.subscription },
            on: {
              change: _vm.onSubscriptionChange,
              hidden: function($event) {
                _vm.showEditPopUp = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }